<template>
  <router-view v-wechat-title="$route.meta.title"/>
</template>

<style>

</style>
